import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgLogoPrimary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 53,
    viewBox: "0 0 48 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M20.64 2.602c3.425.867 4.77 3.295 5.723 4.64 2.168 3.078 3.079 6.85 5.94 11.013 2.732 3.946 10.45 3.902 13.009-.26 3.599-5.81.13-13.355-10.537-16.868-10.06-3.295-19.078 1.778-19.078 1.778 1.604-.563 3.295-.694 4.943-.303ZM42.45 45.876c-14.136.086-25.28-23.068-30.44-33.995-.996-2.168-3.555-3.165-5.723-2.168-.78.347-1.43.91-1.864 1.604-8.109 12.228-4.77 28.661 7.458 36.727 4.336 2.861 9.452 4.422 14.656 4.422.26 0 .52-.043.823-.043 12.358.087 20.683-8.629 20.683-8.629a9.744 9.744 0 0 1-5.593 2.082Z",
    fill: "currentColor"
  }));
}

export { SvgLogoPrimary as default };
